import { render, staticRenderFns } from "./popup-share-tips.vue?vue&type=template&id=e7b06cd6&scoped=true&"
import script from "./popup-share-tips.vue?vue&type=script&lang=js&"
export * from "./popup-share-tips.vue?vue&type=script&lang=js&"
import style0 from "./popup-share-tips.vue?vue&type=style&index=0&id=e7b06cd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b06cd6",
  null
  
)

export default component.exports